import React, { Component } from 'react'
import Button from 'react-bootstrap/Button'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

export class Downloader extends Component {
    constructor(props) {
        super(props);
        this.type = this.props.type; // 'log' or 'trace'
        this.nameSuffix = this.type === 'log' ? '_event_' : '_call_'; // Assuming 'trace' type should be named '_call_'
    }

    render() {
        const { tables, contract, dataset } = this.props;
        return (
            <div>
                <Button
                    variant="success"
                    type="submit"
                    onClick={() => {
                        const eventsOrCalls = Object.entries(tables).filter(q => q[1].parser.type === this.type);
                        const zip = new JSZip();

                        eventsOrCalls.forEach(obj => {
                            const tableName = contract + this.nameSuffix + obj[0];
                            obj[1].table.dataset_name = dataset;
                            obj[1].table.table_name = tableName;
                            const blob = new Blob([JSON.stringify(obj[1], null, 4)], { type: 'application/json' });
                            zip.file(tableName + '.json', blob);
                        });

                        // Generate the zip file and trigger download
                        zip.generateAsync({ type: 'blob' }).then((content) => {
                            saveAs(content, `${contract}${this.nameSuffix}tables.zip`);
                        });
                    }}
                >Download Zipped Table Definitions for {this.type === 'log' ? 'Events' : 'Calls'}</Button>
            </div>
        )
    }
}

export default Downloader
